import { render } from "./chooseGoods.vue?vue&type=template&id=4c493ce9&scoped=true"
import script from "./chooseGoods.vue?vue&type=script&lang=js"
export * from "./chooseGoods.vue?vue&type=script&lang=js"

import "./chooseGoods.vue?vue&type=style&index=0&id=4c493ce9&scoped=true&lang=css"

import exportComponent from "/root/workspace/cinema-admin_TXA8/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c493ce9"]])

export default __exports__